import useApiMutation from 'shared/hooks/use-api-mutation';
import {ProductProps} from '../types';
import productsKeys from '../util/products-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useEditAdditionalGroupConfig = (
  productId: string,
  additionalGroupConfigId: string,
) => {
  const {setData} = useQueryHelpers();

  const onSuccess = (data: ProductProps) =>
    setData(productsKeys.details(productId), data);

  return useApiMutation<ProductProps>({
    url: `/products/${productId}/additional-groups-config/${additionalGroupConfigId}`,
    method: 'PATCH',
    errorTitle: 'Erro ao atualizar grupo de adicionais do produto',
    successTitle: 'Atualizar grupo de adicionais',
    successMessage: 'Grupo de adicionais atualizado com sucesso',
    redirectUrl: (data) => `/menu/products/${data.id}/additional-group-configs`,
    onSuccess,
  });
};

export default useEditAdditionalGroupConfig;
